<template>
    <div
            id="video-dropdown-options"
            class="cb-dropdown"
            @click="preventClickAction"
    >
        <h6>Select a Camera</h6>
        <ul class="submenu">
            <li
                    v-for="input in videoInput"
                    @click="changeSelectedVideoInput(input.key)"
                    :key="input.key"
            >
                <a class="cursorPointer">
          <span class="icon-tick" v-if="selectedVideoInput === input.key">
            <i class="bi bi-check2"></i>
          </span>

                    <i class="fa fa-chevron-right mr-1"></i>
                    <span class="list-option"> {{ input.value }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapMutations, mapGetters } from "vuex";

    export default {
        name: "VideoDevice",
        data() {
            return {};
        },
        computed: {
            ...mapGetters("meet", {
                videoInput: "getVideoInput",
                isCameraStreamReady: "getIsCameraStreamReady",
                selectedVideoInput: "getSelectedVideoInput",
                meetDetails: "getMeetDetails"
            })
        },
        methods: {
            ...mapMutations("meet", {
                setSelectedVideoInput: "setSelectedVideoInput"
            }),

            /**
             * Function to change the camera (video input)
             */
            changeSelectedVideoInput(value) {
                // If user video is muted or screen is shared or camera stream is not ready then return false
                if (
                    "screen" === this.meetDetails.videoTrackType ||
                    !this.isCameraStreamReady ||
                    this.meetDetails.isUserVideoMuted
                ) {
                    return false;
                }

                // If user is changing changing to earlier video input, return false
                if (this.selectedVideoInput === value) {
                    return false;
                }

                // Sets selected video input
                this.setSelectedVideoInput(value);
            },

            /**
             * Prevents click action
             */
            preventClickAction(event) {
                event.stopPropagation();
            }
        }
    };
</script>

<style scoped>
    #video-dropdown-options {
        /* display: none; */
    }

    #video-dropdown-options.show {
        display: block;
    }

    #video-dropdown-options h6 {
        margin: 5px 0 0 0;
    }
</style>